import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddCustomerInput, CustomerDropdownResult, CustomerFullResult, CustomerInformationResult, CustomerResult, EditCustomerInput, GetCustomerInformationsInput, GetCustomersInput, Result, ResultList, SingleResult } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(private httpClient: HttpClient) { }

  public addCustomer(customerInput: AddCustomerInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'Customer/AddCustomer', customerInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editCustomer(id: number, customerInput: EditCustomerInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'Customer/EditCustomer?id=' + id, customerInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteCustomer(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'Customer/DeleteCustomer?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getCustomers(getCustomersInput: GetCustomersInput): Promise<ResultList<CustomerResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'Customer/GetCustomers', getCustomersInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<CustomerResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<CustomerResult>(), result.error));
  }

  public getCustomersInformation(getCustomerInformationsInput: GetCustomerInformationsInput): Promise<ResultList<CustomerInformationResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'Customer/GetCustomersInformation', getCustomerInformationsInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<CustomerInformationResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<CustomerInformationResult>(), result.error));
  }

  public getCustomer(id: number): Promise<SingleResult<CustomerFullResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'Customer/GetCustomer?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new SingleResult<CustomerFullResult>(CustomerFullResult), result))
      .catch(result => plainToClassFromExist(new SingleResult<CustomerFullResult>(CustomerFullResult), result.error));
  }

  public getCustomerdropdown(): Promise<ResultList<CustomerDropdownResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'Customer/GetCustomerDropdown', Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<CustomerDropdownResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<CustomerDropdownResult>(), result.error));
  }

  public getCustomerForProject(): Promise<ResultList<CustomerDropdownResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'Customer/GetCustomerForProject', Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<CustomerDropdownResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<CustomerDropdownResult>(), result.error));
  }
}
